import React from "react";
import parser, { Heading } from "../lib/parser";
import clsx from "clsx";
import { AnchorLink } from "gatsby-plugin-anchor-links";

interface IPostToCProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

interface IEntryProps extends React.PropsWithChildren {
  indent?: boolean;
  heading: Heading;
}

function Entry(props: IEntryProps) {
  const { indent = false, heading } = props;

  return (
    <li
      key={heading.id}
      className={clsx("my-2", {
        "ml-4": indent,
      })}
    >
      <AnchorLink to={`#${heading.id}`} className={clsx()}>
        {heading.text}
      </AnchorLink>
      {heading.children.length > 0 && (
        <ul className={clsx("list-disc")}>
          {heading.children.map((child) => {
            return <Entry key={child.id} heading={child} indent={true} />;
          })}
        </ul>
      )}
    </li>
  );
}

export default function PostToC(props: IPostToCProps) {
  const { post } = props;
  if (!post.content) return <></>;

  const toc = parser.toc(post.content);

  return (
    <div
      className={clsx(
        "bg-base-200",
        "flex",
        "flex-col",
        "items-center",
        "lg:max-w-3xl",
        "md:max-w-2xl",
        "rounded",
        "px-8",
        "py-6",
        "space-y-6",
        "w-full",
      )}
    >
      <p className={clsx("border-b-2", "border-primary", "font-bold")}>目次</p>
      <ul className={clsx("list-disc", "text-sm")}>
        {toc.map((item) => {
          return <Entry key={item.id} heading={item} />;
        })}
      </ul>
    </div>
  );
}
